<template>
  <main role="main" >
    <Banner></Banner>

    <IndexNews></IndexNews>
      
    <IndexActivity></IndexActivity>
    
    <IndexFooter></IndexFooter>
    <div class="privacy-agree" v-if="!closePrivacy">
        <ul >
            <li v-html="$t('INDEX.PRIVACY.DESC')"></li>
            <li @click="Close()" style="cursor:pointer">
                <a v-html="$t('INDEX.PRIVACY.BUTTON')"> </a>
            </li>
        </ul>
    </div>
  </main>
</template>
<script>

export default {
  name: 'index',
  data () {
    return {
      closePrivacy:false,
      lang:''
    }
  },
  mounted () {
    this.lang = localStorage.getItem('language') || 'zh';
    var privacy =  localStorage.getItem("privacy"); 
    if ( privacy ) this.closePrivacy = true;
  },
  created(){
  },
  methods: {
      Close(){
        localStorage.setItem("privacy", true); 
        this.closePrivacy = true;
      }
  }
}
</script>
<style scoped>
.h5-en{
  margin-bottom: 14px !important;
}
.h3-en{
  font-size:36px !important;
  margin-bottom:16px !important;
}
.p-en{
  font-size:16px !important;
  margin-bottom: 20px !important;
}
.privacy-agree{
  z-index: 2000;
}
</style>


// WEBPACK FOOTER //
// src/components/index/Index.vue